import React, { useReducer, useEffect, useState, useContext } from "react";
import { Row } from "../../../../common/columns";
import { reducer } from "./RequestPreviewDocumentsPageReducer";
import { useTranslation } from "react-i18next";
import ErrorSupplementTextarea from "../previewDocuments/DocumentAcceptance/ErrorSupplementTextarea";
import "./DocumentAcceptancePage.scss";
import RequestDetails from "./DocumentAcceptance/RequestDetails";
import { MessageContext } from "../../../../common/message";
import DocumentAcceptanceActions from "./DocumentAcceptance/DocumentAcceptanceActions";
import DocumentPreview from "./DocumentAcceptance/DocumentPreview";
import { back } from "./PreviewDocumentsUtils";

function DocumentAcceptancePage({
  disabled,
  stated,
  document = null,
  index = null,
  additional = null,
  additionalIndex = null,
  setSelected,
  setIsBlocking,
}) {
  const { t } = useTranslation();
  const message = useContext(MessageContext);

  const [state, dispatch] = useReducer(reducer, stated);

  const [doc, setDoc] = useState(
    additional === "additionalDocs"
      ? state[document][index][additional][additionalIndex]
      : document === "request"
      ? state[document]
      : state[document][index]
  );

  const documentSubmit = (doc) => {
    dispatch({ type: "submit", payload: doc });
    message.toggle({
      title: t("modalMessage.titleInfo"),
      content: t("requests.documentAcceptance.acceptedMsg"),
      hideNo: true,
      yesLabel: t("modalMessage.okLabel"),
      onYes: () => {
        message.toggle({});
        back(setSelected, setIsBlocking, disabled);
      },
    });
  };

  const documentSendBack = (doc) => {
    dispatch({ type: "sendBack", payload: doc });
    message.toggle({
      title: t("modalMessage.titleInfo"),
      content: t("requests.documentAcceptance.sentBackMsg"),
      onNo: () => {
        message.toggle({});
        back(setSelected, setIsBlocking, disabled);
      },
      onYes: () => message.toggle({}),
    });
  };

  const documentRemove = (doc) => {
    message.toggle({
      title: t("modalMessage.titleInfo"),
      content: t("requests.reviewDocuments.additionalDocs.deleteAttachmentMessage"),
      onNo: () => {
        message.toggle({});
      },
      onYes: () => {
        message.toggle({});
        dispatch({ type: "remove", payload: doc });
        back(setSelected, setIsBlocking, disabled);
      },
    });
  };

  useEffect(() => {
    setDoc(
      additional === "additionalDocs"
        ? state[document][index][additional][additionalIndex]
        : document === "request"
        ? state[document]
        : state[document][index]
    );
  }, [document, doc, state, additional, additionalIndex, index]);

  return (
    <div className="block is-centered">
      <div>
        <h2 className="has-text-centered my-2">
          {document === "request" || document === "supplements"
            ? doc.title
            : document === "letters" && additional !== "additionalDocs"
            ? doc.title
            : doc.label}
        </h2>
      </div>

      <Row className="is-centered">
        <RequestDetails docState={{ state, doc }} />
        <DocumentPreview doc={doc} />
        <ErrorSupplementTextarea
          docState={doc}
          disabled={disabled}
          setIsBlocking={setIsBlocking}
          setSelected={setSelected}
        />
      </Row>

      <DocumentAcceptanceActions
        doc={doc}
        stated={stated}
        documentSendBack={documentSendBack}
        documentSubmit={documentSubmit}
        documentRemove={documentRemove}
        setSelected={setSelected}
        setIsBlocking={setIsBlocking}
        disabled={disabled}
      />
    </div>
  );
}

export default DocumentAcceptancePage;
